import { type ProgressBarProps } from './Progressbar.typed';

import * as Styled from './ProgressBar.styled';

const ProgressBar = (props: ProgressBarProps) => {
  const { animationDurationInMilliseconds } = props;

  return (
    <Styled.Container>
      <Styled.Bar
        animationDurationInMilliseconds={animationDurationInMilliseconds}
      />
    </Styled.Container>
  );
};

export { ProgressBar };
